webpackJsonp([279680426466721],{

/***/ 1356:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ApproveCubexTreatmentInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-approve-cubex-treatment-input-87c8c57ece821b0fb3e2.js